import { Component, OnInit } from '@angular/core';
import {
    CommonComponent,
    CommonElementsConfig,
} from '../../common/common.component';

@Component({
    selector: 'app-dialog-ledger-request-withdrawal',
    templateUrl: '../../common/common.component.html',
    styleUrls: ['../../common/common.component.css'],
})
export class WithdrawalComponent extends CommonComponent implements OnInit {
    public override elements = new CommonElementsConfig(['amount', 'comment']);

    public override submitLabel = 'Send Withdrawal Request';
    public override headingLabel = 'Withdrawal Request';

    public override submit() {
        this.message = undefined;
        if (this.formGroup.valid == false) {
            this.message = 'All form fields are required';
            return;
        }

        let payload = {
            request_type: 'withdrawal',
            amount: Number(this.formGroup.get('amount')!.value),
            comment: this.formGroup.get('comment')!.value,
        };

        this.sendPayload('ledger/request', payload);
    }
}
